const WA_URL = 'https://wa.me/573228000501?text=Hola%2C%20me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20sus%20productos';

const steps = [
  {
    icon: 'ri-search-eye-line',
    step: 'Paso 1',
    title: 'Explora el catálogo',
    desc: 'Navega por nuestra colección de perfumes y ropa femenina exclusiva.',
  },
  {
    icon: 'ri-whatsapp-line',
    step: 'Paso 2',
    title: 'Escríbenos por WhatsApp',
    desc: 'Haz clic en "Consultar por WhatsApp" en cualquier producto que te guste.',
  },
  {
    icon: 'ri-heart-line',
    step: 'Paso 3',
    title: 'Recibe atención personalizada',
    desc: 'Te asesoramos, confirmamos disponibilidad y coordinamos tu pedido.',
  },
];

export default function WhatsAppCTA() {
  return (
    <section className="py-20 px-6 bg-charcoal relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 rounded-full bg-gold -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-gold translate-x-1/3 translate-y-1/3" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 bg-[#25D366]/20 text-[#25D366] text-xs font-sans tracking-widest uppercase px-4 py-2 rounded-full mb-5">
            <i className="ri-whatsapp-fill text-base" />
            Compra por WhatsApp
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Compra Fácil por WhatsApp
          </h2>
          <p className="font-sans text-base text-white/70 max-w-xl mx-auto leading-relaxed">
            Explora nuestros productos y contáctanos fácilmente por WhatsApp para conocer precios, disponibilidad y más detalles.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {steps.map((s) => (
            <div
              key={s.step}
              className="flex flex-col items-center text-center bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gold/20 mb-5">
                <i className={`${s.icon} text-3xl text-gold`} />
              </div>
              <span className="font-sans text-xs text-gold tracking-widest uppercase mb-2">
                {s.step}
              </span>
              <h3 className="font-serif text-lg font-semibold text-white mb-3">{s.title}</h3>
              <p className="font-sans text-sm text-white/60 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center gap-4">
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative overflow-hidden bg-[#25D366] hover:bg-[#20BA5A] text-white font-sans font-semibold text-base px-10 py-5 rounded-full transition-all duration-300 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-2xl group-hover:rotate-12 transition-transform duration-300" />
            Escríbenos por WhatsApp ahora
            <i className="ri-arrow-right-line text-lg" />
          </a>
          <p className="font-sans text-xs text-white/40 tracking-wide">
            Respuesta rápida · Atención personalizada · Sin complicaciones
          </p>
        </div>
      </div>
    </section>
  );
}
